import type { User } from '@alltrails/types/User';

function getUserType(user: User | null) {
  if (user?.subscriptionTier === 'peak') {
    return 'peak';
  }

  if (user?.subscriptionTier === 'plus') {
    return 'pro';
  }

  return 'free';
}

export default getUserType;
